import { render, staticRenderFns } from "./GenericEvalsList.vue?vue&type=template&id=27750dac&scoped=true&"
import script from "./GenericEvalsList.vue?vue&type=script&lang=js&"
export * from "./GenericEvalsList.vue?vue&type=script&lang=js&"
import style0 from "./GenericEvalsList.vue?vue&type=style&index=0&id=27750dac&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27750dac",
  null
  
)

export default component.exports